import { render, staticRenderFns } from "./info-editor.vue?vue&type=template&id=59ce203f"
import script from "./info-editor.vue?vue&type=script&lang=ts"
export * from "./info-editor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ce203f')) {
      api.createRecord('59ce203f', component.options)
    } else {
      api.reload('59ce203f', component.options)
    }
    module.hot.accept("./info-editor.vue?vue&type=template&id=59ce203f", function () {
      api.rerender('59ce203f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "admin-components/info-editor.vue"
export default component.exports